const dountChartBgColor = [
  "#00778B",
  "#A6D8A8",
  "#6CC0E5",
  "#75B4A6",
  "#508991",
  "#2F4858",
]
const dountChartHoverBgColor = [
  "#00778B",
  "#91C49A",
  "#5AA9CC",
  "#6AA49B",
  "#457B89",
  "#26404D",
]

export { dountChartBgColor, dountChartHoverBgColor }
